import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

import LadderSvg from './icons/ladder.svg?react';
import HelmetSvg from './icons/helmet.svg?react';
import BootSvg from './icons/boot.svg?react';
import SteeringWheelSvg from './icons/steering-wheel.svg?react';
import ScbaSvg from './icons/scba.svg?react';
import PantsSvg from './icons/pants.svg?react';

const makeIcon = (Component, name) => {
    const Icon = props => <SvgIcon component={Component} inheritViewBox {...props} />;
    Icon.displayName = name;
    return Icon;
};

export const Ladder = makeIcon(LadderSvg, 'Ladder');
export const Helmet = makeIcon(HelmetSvg, 'Helmet');
export const Boot = makeIcon(BootSvg, 'Boot');
export const SteeringWheel = makeIcon(SteeringWheelSvg, 'SteeringWheel');
export const SCBA = makeIcon(ScbaSvg, 'SCBA');
export const Pants = makeIcon(PantsSvg, 'Pants');
